/**
* @summary - Component that Provides Work Group Listing Page
* @author Yuvasri S
* @since 2024-05-28
*/
import React from 'react'
import WorkGroupList from '../../components/workgroupcomponents/WorkGroupList';
import { useSelector } from 'react-redux';

function WorkGroupDetails({renderPageContent}) {
    const headerName= useSelector(state => state.authendicationReducer.headerName); 

    if (headerName === 'Hospital Masters') {
        return (
            <>
                {/*Dynamic content goes here */}
                <WorkGroupList renderPageContent={renderPageContent} />
            </>
        );
    } else {
        // If headerName doesn't match, return null or any other desired behavior
        return null; // or any other fallback component
    }
}

export default WorkGroupDetails;